import PanelSubMenus        from "../views/template/SubMenus.vue";
import Perfiles             from "../views/catalogos/perfiles/List.vue";
import AsignarPermisosUsuario from "../views/modulos/empresa/asignarPermisosUsuario/Form.vue";
import Puestos              from "../views/catalogos/puestos/List.vue";
import Permisos             from "../views/catalogos/permisos/List.vue";
import Paneles              from "../views/catalogos/paneles/List.vue";
import AsigPermisos         from "../views/catalogos/menusxPerfil/AsignarList.vue";
import Correo               from "../views/catalogos/correo/Form.vue";
import Notificacion         from "../views/catalogos/notificacion/List.vue";
import NotificacionDetalle  from "../views/catalogos/notificacion/notificacionDetalle/List.vue";

import Acciones             from "../views/catalogos/accion/List.vue";
import TipoDeEvento         from "../views/catalogos/tipoEvento/List.vue";
import TipoDeDescarto       from "../views/catalogos/tipoDescarto/List.vue";
import Departamento         from "../views/catalogos/departamento/List.vue";
import CategoriaGaleria     from "../views/catalogos/categoriaGaleria/List.vue";
import GaleriaImagen        from "../views/catalogos/bancoImagen/List.vue";
import GaleriaImagenForm    from "../views/catalogos/bancoImagen/Form.vue";
import Agente               from "../views/catalogos/agente/List.vue";
import AgenteForm           from "../views/catalogos/agente/Form.vue";
import Comision             from "../views/catalogos/comision/List.vue";
import Folio                from "../views/catalogos/folio/List.vue";
import Destinatario         from "../views/catalogos/destinatario/Form.vue";
import Paquete              from "../views/catalogos/paquetehotel/List.vue";
import ElementoPaquete      from "../views/catalogos/elementopaquete/List.vue";
import ElementoPaqueteForm  from "../views/catalogos/elementopaquete/Form.vue";
import UsuarioxAgente       from  "../views/catalogos/usuarioxagente/List.vue";
import BancoImagenxProducto from  "../views/catalogos/bancoImagenProducto/List.vue";
import BancoImagenxProductoForm from  "../views/catalogos/bancoImagenProducto/Form.vue";
import ImagenContrato       from  "../views/catalogos/imagenContrato/List.vue";



const VarRutasConfiguracion = [
    {
        path: '/Acciones',
        name: 'accion',
        component: Acciones,
        props: false
    }, {
        path: '/TipoDeEvento',
        name: 'tipoEvento',
        component: TipoDeEvento,
        props: false
    }, {
        path: '/TipoDeDescarto',
        name: 'tipoDescarto',
        component: TipoDeDescarto,
        props: false
    }, {
        path: '/Departamentos',
        name: 'departamento',
        component: Departamento,
        props: false
    }, {
        path: '/CategoriasDeLaGaleria',
        name: 'categoriaGaleria',
        component: CategoriaGaleria,
        props: false
    }, {
        path: '/GaleriaImagen',
        name: 'galeriaImagen',
        component: GaleriaImagen,
        props: true
    }, {
        path: '/GaleriaImagenForm',
        name: 'galeriaImagenForm',
        component: GaleriaImagenForm,
        props: true
    },{
        path: '/HotelEmpresa',
        name: 'hotelEmpresa',
        component: Agente,
        props: false
    }, {
        path: '/HotelEmpresaForm',
        name: 'agenteForm',
        component: AgenteForm,
        props: true
    }, {
        path: '/Comision',
        name: 'comision',
        component: Comision,
        props: false
    }, {
        path: '/PanelDetalle',
        name: 'panelSubMenus',
        component: PanelSubMenus,
        props: true
    }, {
        path: '/Perfiles',
        name: 'perfiles',
        component: Perfiles,
        props: true
    }, {
        path:'/AsignarPermisosUsuario',
        name: 'asignarpermisosusuario',
        component: AsignarPermisosUsuario,
        props: true,
    }, {
        path: '/Puestos',
        name: 'puestos',
        component: Puestos,
        props: true
    }, {
        path: '/Paneles',
        name: 'paneles',
        component: Paneles,
        props: true
    }, {
        path: '/Permisos',
        name: 'permisos',
        component: Permisos,
        props: false
    }, {
        path: '/AsignarPermiso',
        name: 'asignarPermisos',
        component: AsigPermisos,
        props: true
    }, {
        path: '/ConfiguracionCorreoElectronico',
        name: 'correo',
        component: Correo,
        props: true
    }, {
        path: '/Folios',
        name: 'folio',
        component: Folio,
        props: true
    }, {
        path: '/Destinatarios',
        name: 'destinatario',
        component: Destinatario,
        props: true
    }, {
        path: '/Paquetes',
        name: 'paquete',
        component: Paquete,
        props: true
    }, {
        path: '/ElementosPaquetes',
        name: 'elementopaquete',
        component: ElementoPaquete,
        props: true
    },
    {
        path: '/ElementosPaqueteForm',
        name: 'elementopaqueteform',
        component: ElementoPaqueteForm,
        props: true
    },
    {
        path: '/Coordinadores',
        name: 'coordinadores',
        component: UsuarioxAgente,
        props: true
    }, {
        path: '/BancoImagenProductos',
        name: 'BancoImagenProductos',
        component: BancoImagenxProducto,
        props: true
    }, {
        path: '/BancoImagenProductosForm',
        name: 'BancoImagenProductosForm',
        component: BancoImagenxProductoForm,
        props: true
    }, {
        path: '/ImagenesContrato',
        name: 'imagencontrato',
        component: ImagenContrato,
        props: true
    }, {
        path: '/Notificacion',
        name: 'notificacionesConfig',
        component: Notificacion,
        props: true
    } , {
        path: '/Notificacion',
        name: 'notificacionesConfigDetalle',
        component: NotificacionDetalle,
        props: true
    } 
];

export default {
    VarRutasConfiguracion,
}
